module.exports = "<app-navbar></app-navbar>\n<app-profilecenter></app-profilecenter>\n<app-footer></app-footer>\n\n"